/**
 * Data from consumer comes in a 1d-Array and we need to turn it into an uneven
 * 2d-grid (the hive). This method return which x,y position correspond to an
 * index in the array.
 * @param index -
 * @param colsByOddRow -
 */
export const unflattenPosition = (index: number, colsByOddRow: number) => {
  const blockSize = 2 * colsByOddRow - 1;
  const currentBlock = Math.floor(index / blockSize);
  const blockPosition = index % blockSize;

  const currentRow =
    blockPosition >= colsByOddRow ? currentBlock * 2 + 1 : currentBlock * 2;

  const currentColumn =
    blockPosition >= colsByOddRow
      ? blockPosition - colsByOddRow
      : blockPosition;

  return { x: currentColumn + 1, y: currentRow + 1 };
};
